import { useContext } from "react";

import { AnalyticsContext } from "../contexts/dashboard/AnalyticsContext";

const useAnalytics = () => useContext(AnalyticsContext);

export default useAnalytics;
